import axios from 'axios'
import { Toast } from 'vant'
import local from './local'
import Vue from 'vue';
Vue.use(Toast);

// axios.defaults.baseURL = 'https://nydev.yunnenghulian.com/' // 测试
axios.defaults.baseURL = 'https://imember.yunnenghulian.com/' // 线上
axios.defaults.timeout = 10000 // 请求超时时间



// 请求拦截器
axios.interceptors.request.use(
    (config) => {
        // config是请求配置对象
        const token = local.get('t_k')

        // 请求头统一携带token
        if (token) {
            config.headers.access_token = token
        }
        return config
    },
    (err) => {
        return Promise.reject(err)
    }
)

// 响应拦截器
axios.interceptors.response.use(
    (response) => {
        // resposne后端响应的数据
        const res = response.data

        // 统一处理状态码
        if (res.code === 105) {
            Toast('登录过期 ,请重新登录')
            local.clear()
            window.location.href = '/' // 跳转到登录页面
        }

        return response
    },
    (err) => {
        Toast.fail(err.response.data.msg);
        return Promise.reject(err)
    }
)

// 暴露出去
export default axios


// WEBPACK FOOTER //
// ./src/api/index.js